import React from 'react';
import { Alert, AlertTitle, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ConnectionStatusProps {
  isConnected: boolean;
  lastError: string | null;
  reconnect: () => void;
}

const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ isConnected, lastError, reconnect }) => {
  const { t } = useTranslation();
  
  if (isConnected) return null;
  
  return (
    <Alert 
      severity="error" 
      sx={{ mb: 2 }}
      action={
        <Button color="inherit" size="small" onClick={reconnect}>
          {t('chat.refresh')}
        </Button>
      }
    >
      <AlertTitle>{t('chat.disconnected')}</AlertTitle>
      {lastError || t('chat.websocket_disconnected')}
    </Alert>
  );
};

export default ConnectionStatus; 